export default {
      id: "back_arrow-usage",
      viewBox: "0 0 17 15",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#back_arrow",
      toString: function () {
        return this.url;
      }
    }